import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  Avatar,
  Grid,
  Paper,
  Breadcrumbs,
  Link,
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Stack,
  CssBaseline,
  Divider,
  TableContainer,
} from "@mui/material";
import { alpha } from '@mui/material/styles';
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import EditarProveedorDialog from "./editarproveedordialog";
import AppTheme from '../../../../shared-theme/AppTheme';
import AppNavbar from '../../../../components/AppNavbar';
import SideMenu from '../../../../components/SideMenu';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../../../dashboard/theme/customizations';
import Header from "../../../../components/Header";
import { Edit } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { StyledCellHeader } from "../../../../components/StyledCellHeader";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};



const purchases = [
  {
    number: "PO-2023-001",
    date: "2023-03-15",
    amount: "$5,000",
    status: "Completed"
  },
  {
    number: "PO-2023-002",
    date: "2023-04-20",
    amount: "$10,000",
    status: "In Progress"
  },
  {
    number: "PO-2023-003",
    date: "2023-05-10",
    amount: "$2,500",
    status: "Pending Approval"
  },
  {
    number: "PO-2023-004",
    date: "2023-06-05",
    amount: "$7,500",
    status: "Completed"
  },
  {
    number: "PO-2023-005",
    date: "2023-07-12",
    amount: "$12,000",
    status: "In Progress"
  }
];

const statusColor = status => {
  switch (status) {
    case "Active":
      return "success";
    case "Inactive":
      return "default";
    default:
      return "primary";
  }
};

const purchaseStatusColor = status => {
  switch (status) {
    case "Completed":
      return "success";
    case "In Progress":
      return "warning";
    case "Pending Approval":
      return "info";
    default:
      return "default";
  }
};

export default function ProviderDetails(props) {

  const [provider, setProvider] = React.useState({});
  const [purchases, setPurchases] = React.useState([]);
  const [openEditDialog, setOpenEditDialog] = React.useState(false);
  const { id } = useParams();

  React.useEffect(() => {
    getProvider();
    getPurchases()
  }, []);

  async function getProvider() {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/proveedores/${id}`);
    const data = await response.json();
    setProvider(data);
  }

  async function getPurchases() {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/ordenes-compra/proveedor/${id}`);
    const data = await response.json();
    setPurchases(data);
  }


  async function updateProvider(data) {
    setProvider(data);
    setOpenEditDialog(false);
  }
  

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}>
            <EditarProveedorDialog open={openEditDialog} onClose={() => setOpenEditDialog(false)} provider={provider} onUpdate={updateProvider} />
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Box sx={{ minHeight: "100vh", bgcolor: "#fff", fontFamily: 'Inter, "Noto Sans", sans-serif', width: '100%' }}>
              {/* Main content */}
              <Box px={20} py={5} display="flex" justifyContent="center" flex={1}>
                <Box width="100%">
                <Header parent={"Logistica y Almacenes"} child={"Proveedores"}/>

                  {/* Title and Edit */}
                  <Box p={2} display="flex" alignItems="center" justifyContent="space-between">
                    <Typography fontSize={32} fontWeight={700} color="#111518" minWidth={250}>
                      {provider.name}
                    </Typography>
                    <Button
                      startIcon={<Edit />}
                      variant="contained"
                      color="primarybutton"
                      sx={{
                        fontWeight: "bold",
                        fontSize: 15,
                        boxShadow: "none",
                        minWidth: 120,
                      }}
                      onClick={() => setOpenEditDialog(true)}>
                      Editar
                    </Button>
                  </Box>

                  {Object.keys(provider).length > 0 && (
                    <Card sx={{ my: 2, boxShadow: 2, border: "none", backgroundColor: "white" }}>
                        <CardContent>
                        <Grid container spacing={0}>
                          <Grid item size={12}>
                            <Typography px={2} pb={1} pt={3} variant="h6" fontWeight={700} color="#111518" textAlign={"left"}>
                              Información General
                            </Typography>
                          </Grid>
                            <Grid item size={{xs:12, sm:6}} sx={{ borderTop: "1px solid #dbe1e6", py: 2, pr: 2 }}>
                            <Typography variant="body2" color="#617689">
                                Nombre
                            </Typography>
                            <Typography color="#111518">{provider.nombre}</Typography>
                            </Grid>
                            <Grid item size={{xs:12, sm:6}} sx={{ borderTop: "1px solid #dbe1e6", py: 2, pl: 2 }}>
                            <Typography variant="body2" color="#617689">
                                RNC
                            </Typography>
                            <Typography color="#111518">{provider.rnc}</Typography>
                            </Grid>
                            <Grid item size={{xs:12, sm:6}} sx={{ borderTop: "1px solid #dbe1e6", py: 2, pr: 2 }}>
                            <Typography variant="body2" color="#617689">
                                Dirección
                            </Typography>
                            <Typography color="#111518">{provider.direccion}</Typography>
                            </Grid>
                            <Grid item size={{xs:12, sm:6}} sx={{ borderTop: "1px solid #dbe1e6", py: 2, pl: 2 }}>
                            <Typography variant="body2" color="#617689">
                                Contacto
                            </Typography>
                            <Typography color="#111518">{provider.contacto}</Typography>
                            </Grid>
                            <Grid item size={{xs:12, sm:6}} sx={{ borderTop: "1px solid #dbe1e6", py: 2, pr: 2 }}>
                            <Typography variant="body2" color="#617689">
                                Teléfono
                            </Typography>
                            <Typography color="#111518">{provider.telefono}</Typography>
                            </Grid>
                            <Grid item size={{xs:12, sm:6}} sx={{ borderTop: "1px solid #dbe1e6", py: 2, pl: 2 }}>
                            <Typography variant="body2" color="#617689">
                                Correo Electrónico
                            </Typography>
                            <Typography color="#111518">{provider.email}</Typography>
                            </Grid>
                            <Grid item size={{xs:12, sm:6}} sx={{ borderTop: "1px solid #dbe1e6", py: 2, pr: 2 }}>
                            <Typography variant="body2" color="#617689">
                                Estado
                            </Typography>
                            <Chip
                                label={provider.estado}
                                color={statusColor(provider.estado)}
                                sx={{ fontWeight: 500 }}
                                size="small"
                            />
                            </Grid>
                            <Grid item size={{xs:12, sm:6}} sx={{ borderTop: "1px solid #dbe1e6", py: 2, pl: 2 }}>
                            <Typography variant="body2" color="#617689">
                                Fecha de Creación
                            </Typography>
                            <Typography color="#111518">{provider.fecha_creacion}</Typography>
                            </Grid>
                        </Grid>
                        </CardContent>
                    </Card>
                  )}
                  {/* Recent Purchases */}
                  <Box sx={{ px: 2, py: 2, borderRadius: 2, boxShadow: "none", border: "1px solid #dbe1e6" }}>
                    <Typography px={2} pb={1} pt={3} variant="h6" fontWeight={700} color="#111518" textAlign={"left"}>
                        Órdenes de Compra
                      </Typography>

                      <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: "none", minHeight: "500px" }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <StyledCellHeader>Numero de Orden</StyledCellHeader>
                              <StyledCellHeader>Fecha de Emisión</StyledCellHeader>
                              <StyledCellHeader>Total Estimado</StyledCellHeader>
                              <StyledCellHeader>Estado</StyledCellHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {purchases.map(row => (
                              <TableRow key={row.id} sx={{ borderTop: "1px solid #dbe1e6" }}>
                                <TableCell>{row.numero_orden}</TableCell>
                                <TableCell sx={{ color: "#617689" }}>{row.fecha_emision}</TableCell>
                                <TableCell sx={{ color: "#617689" }}>{row.total_estimado}</TableCell>
                                <TableCell>
                                  <Chip
                                    label={row.estado}
                                    color={purchaseStatusColor(row.estado)}
                                    size="small"
                                    sx={{ fontWeight: 500 }}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                    </TableContainer>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}
